import React from 'react';
import NegativeToast from '@/components/toasts/NegativeToast';
import ToastMessage from '@/components/toasts/ToastMessage';

const TokenExpiredToast = ({ items }) => (
  <NegativeToast className="aridhia-token-expired-toast" icon="wait">
    <ToastMessage items={items} multiple="toast.expires" single="toast.expired" />
  </NegativeToast>
);

export default TokenExpiredToast;
